import { render, staticRenderFns } from "./AddMainPage.vue?vue&type=template&id=2dfd9a0c&scoped=true&"
import script from "./AddMainPage.vue?vue&type=script&lang=js&"
export * from "./AddMainPage.vue?vue&type=script&lang=js&"
import style0 from "./AddMainPage.vue?vue&type=style&index=0&id=2dfd9a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd9a0c",
  null
  
)

export default component.exports